// Guard de autenticación — verifica y gestiona el token
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  // Caso 1: Token válido → permitir acceso
  if (authService.isTokenValid()) {
    return true;
  }

  // Caso 2: Token expirado pero existe → intentar renovar
  if (authService.getAccessToken()) {
    return authService.refreshToken().pipe(
      map(() => true),
      catchError((_error) => {
        redirectToLanding();
        return of(false);
      }),
    );
  }

  // Caso 3: Sin token → obtener uno nuevo
  return authService.fetchToken().pipe(
    map(() => true),
    catchError((_error) => {
      redirectToLanding();
      return of(false);
    }),
  );
};

/** Redirige a la URL de landing configurada en environment */
function redirectToLanding(): void {
  if (environment.landingUrl) {
    window.location.replace(environment.landingUrl);
  }
}
